import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Menu, Grid } from "antd";
import IntlMessage from "../util-components/IntlMessage";
import Icon from "../util-components/Icon";
import navigationConfig from "configs/NavigationConfig";
import { connect } from "react-redux";
import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE } from "constants/ThemeConstant";
import utils from 'utils'
import { onMobileNavToggle } from "redux/actions/Theme";
import { useLocation } from "react-router-dom";
import * as perRes from '../../services/PermissionsResolver'
import { Fragment } from "react";

const { SubMenu } = Menu;
const { useBreakpoint } = Grid;

const setLocale = (isLocaleOn, localeKey) =>
  isLocaleOn ? <IntlMessage id={localeKey} /> : localeKey.toString();

const setDefaultOpen = (key) => {
  let keyList = [];
  let keyString = "";
  if (key) {
    const arr = key.split("-");
    for (let index = 0; index < arr.length; index++) {
      const elm = arr[index];
      index === 0 ? (keyString = elm) : (keyString = `${keyString}-${elm}`);
      keyList.push(keyString);
    }
  }
  return keyList;
};

const SideNavContent = (props) => {
  const { sideNavTheme, routeInfo, hideGroupTitle, localization, onMobileNavToggle } = props;
  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes('lg')
  const closeMobileNav = () => {
    if (isMobile) {
      onMobileNavToggle(false)
    }
  }


  const resolvePermission = (permission) => {
    return true;
  }

  const [currentPath, setCurrentPath] = useState('')
  const [openKeys, setOpenKeys] = useState(setDefaultOpen(routeInfo?.key))
  const location = useLocation();

  useEffect(() => {
    setCurrentPath(location.pathname)
    
    // Close submenus when navigating to a path that is not part of them
    const currentOpenKeys = [...openKeys];
    const shouldCloseSubmenus = currentOpenKeys.filter(key => {
      const menuItem = navigationConfig.find(m => m.key === key);
      if (menuItem && menuItem.path) {
        return location.pathname.includes(menuItem.path);
      }
      return true;
    });
    
    if (shouldCloseSubmenus.length !== currentOpenKeys.length) {
      setOpenKeys(shouldCloseSubmenus);
    }
  }, [location.pathname])

  const onOpenChange = (keys) => {
    setOpenKeys(keys);
  }

  return (
    <Menu
      theme={sideNavTheme === SIDE_NAV_LIGHT ? "light" : "dark"}
      mode="inline"
      style={{ height: "100%", borderRight: 0 }}
      defaultSelectedKeys={[routeInfo?.key]}
      defaultOpenKeys={setDefaultOpen(routeInfo?.key)}
      openKeys={openKeys}
      onOpenChange={onOpenChange}
      className={hideGroupTitle ? "hide-group-title" : ""}
    >
      {navigationConfig.map((menu) => {
        let isAllowed;

        // If permission is an array, check if user has at least one of the permissions
        if (Array.isArray(menu.permission)) {
          isAllowed = menu.permission.reduce((currentStatus, permission) => {
            // Special case for "contracts" menu: also check if user is a customer
            if (menu.key === "contracts") {
              return currentStatus && perRes.resolve(permission, props.currentUser)
            }
            // For other menus, just check the permission
            return currentStatus || perRes.resolve(permission, props.currentUser)
          }, menu.key === "contracts");
        } else {
          // Single permission
          isAllowed = perRes.resolve(menu.permission, props.currentUser);
        }

        // Simple menu
        if (menu.submenu.length === 0) {
          return <Fragment key={menu.key}>
          {isAllowed ?
            <Menu.Item key={menu.key} className={currentPath.includes(menu.path) ? 'ant-menu-item-selected achotio' : ''}>
              {currentPath.includes(menu.path)  ? <img className="img-fluid" src={'/img/sidenav/' + menu.active_icon} alt="" />
                : <img className="img-fluid" src={'/img/sidenav/' + menu.icon} alt="" />}
              <span>{setLocale(localization, menu?.title)}</span>
              {menu.path ? <Link onClick={() => closeMobileNav()} to={menu.path} /> : null}
            </Menu.Item> : ''}
        </Fragment>
        }

        // Menu with subitems
        const isOpen = openKeys.includes(menu.key);
        const isActive = currentPath.includes(menu.path);
        const shouldHighlight = isOpen || isActive;
        
        return <Fragment key={menu.key}>
          {isAllowed ?
            <SubMenu 
              key={menu.key} 
              className={shouldHighlight ? 'ant-menu-submenu-selected achotio' : ''}
              title={
                <span>
                  {shouldHighlight  ? 
                    <img className="img-fluid" src={'/img/sidenav/' + menu.active_icon} alt="" /> :
                    <img className="img-fluid" src={'/img/sidenav/' + menu.icon} alt="" />
                  }
                  <span>{setLocale(localization, menu?.title)}</span>
                </span>
              }
            >
              {
                menu.submenu.map((item) => {
                  const hasPermission = Array.isArray(item.permission)
                    ? item.permission.some(permission => perRes.resolve(permission, props.currentUser))
                    : perRes.resolve(item.permission, props.currentUser);

                  // "Credenciales API" is a Partner/Customer-only self-service screen
                  const itemAllowed = item.key === 'advanced-settings-oauth-credentials'
                    ? hasPermission && ['partner', 'customer'].includes(props.currentUser?.type)
                    : hasPermission;

                  const isItemSelected = currentPath === item.path;
                  
                  return <Fragment key={item.key}>
                    {itemAllowed ?
                      <Menu.Item 
                        key={item.key} 
                        className={isItemSelected ? 'ant-menu-item-selected submenu-item-selected' : 'submenu-item-normal'}
                      >
                        <span>{setLocale(localization, item?.title)}</span>
                        {item.path ? <Link onClick={() => closeMobileNav()} to={item.path} /> : null}
                      </Menu.Item> : null}
                  </Fragment>
                })
              }
            </SubMenu> : ''}
        </Fragment>
    }

      )}
    </Menu>
  );
};

const TopNavContent = (props) => {
  const { topNavColor, localization } = props;
  return (
    <Menu mode="horizontal" style={{ backgroundColor: topNavColor }}>
      {navigationConfig.map((menu) =>
        menu.submenu.length > 0 ? (
          <SubMenu
            key={menu.key}
            popupClassName="top-nav-menu"
            title={
              <span>
                {menu.icon ? <Icon type={menu?.icon} /> : null}
                <span>{setLocale(localization, menu.title)}</span>
              </span>
            }
          >
            {menu.submenu.map((subMenuFirst) =>
              subMenuFirst.submenu.length > 0 ? (
                <SubMenu
                  key={subMenuFirst.key}
                  icon={
                    subMenuFirst.icon ? (
                      <Icon type={subMenuFirst?.icon} />
                    ) : null
                  }
                  title={setLocale(localization, subMenuFirst.title)}
                >
                  {subMenuFirst.submenu.map((subMenuSecond) => (
                    <Menu.Item key={subMenuSecond.key}>
                      <span>
                        {setLocale(localization, subMenuSecond.title)}
                      </span>
                      <Link to={subMenuSecond.path} />
                    </Menu.Item>
                  ))}
                </SubMenu>
              ) : (
                <Menu.Item key={subMenuFirst.key}>
                  {subMenuFirst.icon ? (
                    <Icon type={subMenuFirst?.icon} />
                  ) : null}
                  <span>{setLocale(localization, subMenuFirst.title)}</span>
                  <Link to={subMenuFirst.path} />
                </Menu.Item>
              )
            )}
          </SubMenu>
        ) : (
          <Menu.Item key={menu.key}>
            {menu.icon ? <Icon type={menu?.icon} /> : null}
            <span>{setLocale(localization, menu?.title)}</span>
            {menu.path ? <Link to={menu.path} /> : null}
          </Menu.Item>
        )
      )}
    </Menu>
  );
};

const MenuContent = (props) => {
  return props.type === NAV_TYPE_SIDE ? (
    <SideNavContent {...props} />
  ) : (
    <TopNavContent {...props} />
  );
};

const mapStateToProps = (state) => {
  const { sideNavTheme, topNavColor } = state.theme;
  const currentUser = state.api.currentUser;
  return { sideNavTheme, topNavColor, currentUser };
};

export default connect(mapStateToProps, { onMobileNavToggle })(MenuContent);
